module.exports = __webpack_public_path__ + "media/images/everify-authorized-logo-1673a0b4ca8315903b56e9183c70d723.svg";